export default function Selector({ options = [], selected, onChange, required = false }) {
  return (
    <div className="flex mb-4 w-full">
      <div className="flex gap-4 w-full">
        {options.map((option, index) => (
          <label 
            key={option.value}
            className={`
              cursor-pointer px-4 py-2 border rounded-md w-full truncate
              ${selected === option.value ? "bg-blue-500 text-white border-blue-500" : "bg-white text-gray-700 border-gray-300"}
              transition-colors duration-200
            `}
          >
            <input
              type='radio'
              name='selector'   // одна группа
              value={option.value}
              checked={selected === option.value}
              onChange={() => onChange(option.value)}
              required={required && index === 0} // required на первом
              className="absolute opacity-0 w-0 h-0" // спрятан, но фокусируем
            />
            {option.label}
          </label>
        ))}
      </div>
    </div>
  )
}
